import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import ScrollToTop from '../../components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import ChaptersSection from './components/ChaptersSection';
import TipsSection from './components/TipsSection';
import InsightsSection from './components/InsightsSection';
import ChecklistSection from './components/ChecklistSection';
import FAQSection from './components/FAQSection';

export default function GuiaPalestraSilenciosaPage() {
  useEffect(() => {
    document.title = 'Guia Prático de Palestras Silenciosas | Dicas, Exemplos e Insights — STIB';

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Guia prático gratuito sobre palestras silenciosas: 28 páginas com dicas de especialistas, 5 cases reais detalhados, checklist de planejamento e insights sobre engajamento e organização de eventos. Baixe agora.'
      );
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', 'https://stibpalestrasilenciosasp.com.br/guia-palestra-silenciosa');

    const lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://stibpalestrasilenciosasp.com.br';

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/guia-palestra-silenciosa#webpage`,
          name: 'Guia Prático de Palestras Silenciosas',
          description:
            'Guia prático gratuito com dicas de especialistas, cases reais, checklist de planejamento e insights sobre como palestras silenciosas elevam o engajamento e a organização de eventos.',
          about: {
            '@type': 'Thing',
            name: 'Palestra Silenciosa',
            description: 'Tecnologia de áudio sem fio para eventos corporativos, conferências, treinamentos e festivais.',
          },
          publisher: {
            '@type': 'Organization',
            name: 'STIB — Palestra Silenciosa Brasil',
            url: siteUrl,
          },
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'Guia Prático de Palestras Silenciosas',
              item: `${siteUrl}/guia-palestra-silenciosa`,
            },
          ],
        },
        {
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: 'Preciso ter conhecimento técnico para contratar palestra silenciosa?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Não. O fornecedor cuida de toda a parte técnica. O guia explica o que você precisa saber para fazer as perguntas certas, mas a execução fica com a equipe especializada.',
              },
            },
            {
              '@type': 'Question',
              name: 'Quanto custa em média uma palestra silenciosa?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'O custo varia conforme o número de fones, canais e duração. A economia gerada ao eliminar múltiplas salas e cabines de tradução costuma ser de 40% a 60% em relação ao formato tradicional.',
              },
            },
            {
              '@type': 'Question',
              name: 'Funciona para eventos ao ar livre?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Sim. O sinal de radiofrequência alcança até 100 metros em campo aberto. Para áreas maiores, antenas direcionais garantem cobertura total.',
              },
            },
          ],
        },
      ],
    };

    const existing = document.getElementById('guia-ps-schema');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'guia-ps-schema';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('guia-ps-schema');
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FloatingCTA />
      <ScrollToTop />
      <main>
        <HeroSection />
        <ChaptersSection />
        <TipsSection />
        <InsightsSection />
        <ChecklistSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}